import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import React from 'react';

import {
  CollapsibleContentProps,
  CollapsibleRootProps,
  CollapsibleTriggerProps,
} from './types';

// NOTE: Currently we do not have any designs for a styled version of a generic collapsible component, but if we do in the future it should go here.
// These are intended to be unstyled and more or less re-exported versions of the Radix Collapsible components in order to enable flexible use cases.

const CollapsibleRoot = ({ ...props }: CollapsibleRootProps) => {
  return <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />;
};

const CollapsibleTrigger = React.forwardRef<
  HTMLButtonElement,
  CollapsibleTriggerProps
>(({ ...props }, ref) => {
  return (
    <CollapsiblePrimitive.CollapsibleTrigger
      data-slot="collapsible-trigger"
      {...props}
      ref={ref}
    />
  );
});

const CollapsibleContent = ({ ...props }: CollapsibleContentProps) => {
  return (
    <CollapsiblePrimitive.CollapsibleContent
      data-slot="collapsible-content"
      {...props}
    />
  );
};

export { CollapsibleContent, CollapsibleRoot, CollapsibleTrigger };
